<template>
  <div>
    <b-card id="card-youtube-filters" class="mb-0 w-100">
      <select-network-search 
        :networks_avaibles="networks_avaibles"
        :select_network_dad="select_network"
        @update_select_network="updateSelectNetwork"
        class="select-network-search"
      ></select-network-search>
      <b-row class="m-0 p-0 w-100">
        <!-- audience location -->
        <b-col class="col-12 col-md-6 col-lg filter-outline p-0">
          <b-dropdown block no-caret class="dropdown-filters" variant="outline-gray-light" menu-class="w-100" ref="filter_audience_location">
            <template #button-content>
              <div class="d-flex flex-column justify-content-between h-100">
                <b-form-group class="mb-0">
                  <span class="text-left align-middle color-gray-light d-block">
                    <span class="search-Map-Pin4"></span> {{$t("search.audience_location")}} 
                  </span>
                </b-form-group>
                <p class="text-left font-weight-bold d-block m-0">{{text_audience_location}}</p>
              </div>
            </template>
            <b-dropdown-header :key="update_location" class="b-dropdown-header-location-filter-padding">
              <div v-for="(location, index) in audience_locations" :key="index">
                <audience-location-filter
                  :key="change_audience_location"
                  :show_remove="index > 0"
                  :index="index"
                  :location="location"
                  :only_countries="true"
                  :main_locations_filter="main_locations_filter"
                  @changeLocationAudienceChild="changeLocationAudience"
                  @removeAudienceLocationChild="removeAudienceLocation"
                />
              </div>
              <div v-if="Object.keys(this.audience_locations[0]).length > 0" class="p-custom">
                <hr/>
                <b-link v-show="this.audience_locations.length < 3" @click="addAudienceLocation()" class="text-blue">{{$t('search.addLocation')}}</b-link>
                <div v-show="this.audience_locations.length === 3" class="white-space-wrap">{{$t('search.max3Locations')}}</div>
              </div>
            </b-dropdown-header>
          </b-dropdown>
        </b-col>

        <!-- Audience age -->
        <b-col class="col-md-6 col-lg filter-outline p-0" cols="12">
          <b-dropdown block no-caret class="dropdown-filters" variant="outline-gray-light" menu-class="w-100">
            <template #button-content>
              <div class="d-flex flex-column justify-content-between h-100">
                <b-form-group class="mb-0">
                  <span class="text-left color-gray-light d-block mb-1">
                    <span class="search-Busy-1"></span>{{$t("search.audience_age")}}
                  </span>
                </b-form-group>
                <p class="text-left font-weight-bold m-0">{{audience_ages[1] === 65 && audience_ages[0] === 10 ?  $t('search.realty.any') : getAudienceAge()}}</p>
              </div>
            </template>
            <b-dropdown-header class="p-05 pt-0">
              <slider-range :tooltip="'none'" class="mt-1" :init_range="audience_ages" :interval="1" :max_value="65" :min_value="10" :unit="$t('tiktok.years')" :any_text="$t('search.anyAge')" presets="age" identifier="audience_ages" @changeSlide="changeSlideComponent" :key="audience_ages[0] + audience_ages[1]"/>
              <div class="mb-1 mt-2" v-if="showPercentageAgeAudience()"><span class="avenir-medium">{{$t("search.moreOf")}}</span> {{percentage_audience_age}}% <span class="avenir-medium">{{$t("search.ofAudience")}}</span></div>
              <component
                :is="vue_slider"
                class="mt-1"
                v-if="showPercentageAgeAudience()"
                v-model="percentage_audience_age"
                :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :max="99"
                :min="1"
                :interval="1"
                @drag-end="changeSlide"
                :tooltip="'none'"
              />
            </b-dropdown-header>
          </b-dropdown>
        </b-col>  

        <!-- Audience gender -->
        <b-col  class="col-md-6 col-lg filter-outline p-0" cols="12">
          <b-dropdown block no-caret class="dropdown-filters" variant="outline-gray-light" menu-class="w-100" ref="filter_gender">
            <template #button-content>
              <div class="d-flex flex-column justify-content-between h-100">
                <b-form-group class="mb-0">
                  <span class="text-left align-middle color-gray-light mb-1 d-block">
                    <span class="search-intersex"></span> {{$t("search.audience_gender")}} 
                  </span>
                </b-form-group>
                <p class="text-left font-weight-bold m-0">{{audience_gender !== null ? audience_gender.text : $t('search.realty.any')}}</p>
              </div>
            </template>
            <b-dropdown-header :key="update_gender">
              <div v-for="(gender, index) in $t('instaGen')" :key="index" ref="gender_dropdown">
                <div 
                  :class="`button-gender 
                  ${index === 0 ? 'border-radius-top' : ''} 
                  ${index === $t('instaGen').length -1 ? 'border-radius-bottom' : ''}
                  `"
                  @click="setAudienceGender(gender, index)"
                >
                  {{gender.text}}
                </div>
              </div>
              
              <div v-if="audience_gender !== null ? audience_gender.value !== null : audience_gender !== null">
                <div class="mt-2 white-space-wrap avenir-medium">{{$t('search.more_than')}}<strong>{{percentage_gender}}</strong>%{{$t('search.of_audience')}}</div>

                <component
                  :is="vue_slider"
                  class="mt-1"
                  v-model="percentage_gender"
                  :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :max="99"
                  :min="1"
                  :interval="1"
                  @drag-end="changeSlide"
                  :tooltip="'none'"
                />
              </div>
            </b-dropdown-header>
          </b-dropdown>
        </b-col>     

        <!-- Average views -->
        <b-col class="col-md-6 col-lg filter-outline p-0" cols="12">
          <b-dropdown block no-caret class="dropdown-filters" variant="outline-gray-light" menu-class="w-100">
            <template #button-content>
              <div class="d-flex flex-column justify-content-between h-100">
                <b-form-group class="mb-0">
                  <span class="text-left align-middle color-gray-light mb-1 d-block">
                    <b-icon class="search-icon icon-size-14" icon="eye"/><span class="ml-1">{{$t("search.averageViewsVideo")}}</span>
                  </span>
                </b-form-group>
                <p class="text-left font-weight-bold m-0">{{ getLabelViews() }}</p>
              </div>
            </template>
            <b-dropdown-header class="p-05 pt-0">
              <view-avg-slider
                :init_range="range_views"
                :interval="5000" 
                :max_value="10000000" 
                :min_value="10000" 
                identifier="range_views" 
                @changeSlide="changeSlideComponent" 
                :key="update_view_avg_slider"
                ref="view_avg_slider"
              />
            </b-dropdown-header>
          </b-dropdown>
        </b-col>

        <!--  Submit button -->
        <div class="d-flex align-items-center container-more-filters">
          <b-button variant="outline-secondary" class="d-flex align-items-center justify-content-center w-100" @click="open_sidebar = true"><b-icon icon="filter" class="mr-03"/>{{$t('search.allFilters')}}<b-badge v-if="checkFiltersUsed().length > 0" pill class="ml-1 d-inline-flex align-items-center justify-content-center" style="background-color:#0096fe;">{{ checkFiltersUsed().length }}</b-badge></b-button>
        </div>
    
      </b-row>
    </b-card>
    <search-by-actions
      :data="{
        total_results,
        loading,
        searched,
        categories,
        disabled_custom_category: true
      }"
      @sendFilters="sendFilters()"
      @add_keyword_filter="addKeywordFilter"
      ref="search_by_actions"
      :key="update_search_by"
    ></search-by-actions>
    <apply-filters :filters="checkFiltersUsed()" @deleteFilter="deleteFilter" @updateModel="updateModel" @clearAllFilters="clearFilters"/>
    <b-sidebar 
      v-model="open_sidebar"
      backdrop
      shadow
      right
      width="700px"
      body-class="background-white"
      no-header
      footer-class="background-white footer-sidebar-filters"
      class="sidebar-filters-nets"
    >
    <feather-icon
        class="close-component"
        icon="XIcon"
        size="16"
        @click="open_sidebar = false"
    />
      <b-row class="p-2">
      <!-- Influencer filters -->

        <b-col class="col-12 col-md">
          <div>
            <h4 class="blueC"><strong>{{$t("search.influencer")}}</strong></h4>
          </div>

          <!-- Tamaño de audiencia -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('audience_size')">
                <span class="search-Users"></span><strong>{{$t("search.audienceSize")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_audience_size"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_audience_size"/>
              </span>
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_audience_size">
              <b-dropdown :text="text_followers" no-caret block variant="outline-dark" menu-class="w-100" ref="filter_followers">
                <b-dropdown-header>
                  <followers-filter @changeFollowers="changeFollowers" :key="update_followers_filter"/>
                </b-dropdown-header>
              </b-dropdown>
            </div>
          </div>

          <!-- Ubicación del influencer -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('influencer_location')">
                <span class="search-Map-Pin4"></span><strong> {{$t("search.influencerLocation")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_influencer_location"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_influencer_location"/>
              </span>
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_influencer_location">
              <b-spinner
                v-if="loading_location_influencer"
                variant="primary"
                class="spinner-ubication"
              />
              <component
                v-if="selected_influencer_locations.length < 5"
                :is="vue_autosuggest"
                :suggestions="influencer_locations"
                :limit="10"
                :input-props="input_locations"
                @input="inputInfluencerLocation"
                v-model="influencer_location"
                :get-suggestion-value="getInfluencerLocation"
                :should-render-suggestions="shouldRenderSuggestions"
              >
                <template slot-scope="{suggestion}">
                  <span class="my-suggestion-item">{{ suggestion.item.name }}</span>
                </template>

                <template slot="before-suggestions">
                  <div class="m-1" v-if="influencer_location !== ''">
                    {{$t("search.searchingBy")}}: {{influencer_location}}
                  </div>
                  <hr v-if="influencer_location !== ''">
                </template>
                <template slot="after-suggestions">
                  <div class="m-1" v-if="no_locations_influencer">
                    {{$t("search.noResults")}}
                  </div>
                </template>
              </component>
              <div v-else class="white-space-wrap">{{$t('search.max5Locations')}}</div>
              <div v-if="selected_influencer_locations.length > 0" class="mt-1" :key="update_influencer_location">
                <div
                  v-for="(location, index) in selected_influencer_locations"
                  :key="index"
                >
                  <div v-if="index > 0" class="text-center selected-location-or">{{ $t('search.or') }}</div>
                  <div class="selected-location-item d-flex align-items-center justify-content-between">
                    <span>{{ location.name }}</span>
                    <feather-icon
                      icon="XIcon"
                      size="18"
                      class="cursor-pointer"
                      @click="removeInfluencerLocation(index)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Idioma del influencer -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('influencer_language')">
                <span class="search-Globe-1"></span><strong> {{$t("search.influencerLanguage")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_influencer_language"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_influencer_language"/>
              </span>
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_influencer_language">
              <b-form-select
                v-model="influencer_language"
                :options="$t('instaIdioma')"
              />
            </div>
          </div>

          <!-- Solo verificados -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('is_verified')">
                <span class="search-Check-1"></span><strong> {{$t("search.onlyveri")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_is_verified"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_is_verified"/>
              </span>
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_is_verified">
              <options-filters :options="$t('instaVerificado')" @optionsFilter="filterVerified" :key="update_is_verified"></options-filters>
            </div>
          </div>

          <!-- Tienen información de contacto -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('info_contact')">
                <span class="search-Information-booklet"></span><strong> {{$t("search.contact")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_info_contact"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_info_contact"/>
              </span>              
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_info_contact">
              <options-filters :options="$t('instaContacto')" @optionsFilter="filterHasContacts" :key="update_info_contact"></options-filters>
            </div>
          </div>

          <div class="py-2" v-if="role !== 'espejo'">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('prices')">
                <strong><b-icon class="search-icon" icon="cash"/>{{$t("search.priceInfluencer")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_prices"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_prices"/>
              </span>              
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_prices">
              <slider-range :tooltip="'none'" class="mt-3" :init_range="prices" :interval="10000" :max_value="1000000" :min_value="0" :any_text="$t('search.anyPrice')" :no_max_limit="true" identifier="prices" @changeSlide="changeSlideComponent" :key="prices[0] + prices[1]"/>
            </div>
          </div>
        </b-col>

        <b-col class="col-12 col-md">
          <!-- Filtros rendimiento -->
          <div>
            <h4 class="blueC"><strong>{{$t("search.performance")}}</strong></h4>
          </div>

          <!-- Seguridad de marca -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('brand_safety')">
                <div class="d-flex align-items-start">
                  <span>
                    <strong>{{$t('search.brand_safety')}}</strong>
                    <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_brand_safety"/>
                    <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_brand_safety"/>
                  </span>
                  <b-badge pill class="ml-05 badge-blue-filter-searcher-new">{{ $t('newFeature') }}</b-badge>
                </div>
              </span>
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_brand_safety">
              <brand-safety :brand_safety="brand_safety" :key="update_brand_safety" @changeBrandSafety="changeBrandSafety"/>
            </div>
          </div>

          <!-- Engagement rate -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('engagement_rate')">
                <span class="search-Heart-Beat"></span><strong> {{$t("search.engagementRate")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_engagement_rate"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_engagement_rate"/>
                <div class="my-1" v-if="engagement_rate > 0">{{engagement_rate}} {{$t("search.engagementRate")}}</div>
              </span>
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_engagement_rate">
              <component
                :is="vue_slider"
                :tooltip="'always'"
                class="mt-3"
                v-model="engagement_rate_slider"
                :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :max="40"
                :min="0"
                :interval="0.5"
                @drag-end="changeSlide"
                :tooltip-formatter="() => `${engagement_rate}`"
              />
              <input
                type="number"
                min="0"
                step="0.5"
                class="form-control mt-2"
                v-model.number="engagement_rate"
                @change="changeEngagementInput"
              />
            </div>
          </div>

          <!-- Promedio de comentarios -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('average_comments')">
                <strong><b-icon class="search-icon" icon="chat"/>{{$t("search.averageComments")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_average_comments"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_average_comments"/>
              </span>              
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_average_comments">
              <view-avg-slider
                ref="view_avg_slider_comments"
                :init_range="comments"
                :interval="5000"
                :max_value="10000000"
                :min_value="0"
                identifier="comments"
                @changeSlide="changeSlideComponent"
                :key="update_view_avg_slider_comments"
              />
            </div>
          </div>

          <!-- Promedio de reacciones -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('reactions')">
                <strong><b-icon class="search-icon" icon="camera-video"/>{{$t("search.averageReactions")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_reactions"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_reactions"/>
              </span>              
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_reactions">
              <view-avg-slider
                ref="view_avg_slider_reactions"
                :init_range="reactions"
                :interval="5000"
                :max_value="10000000"
                :min_value="0"
                identifier="reactions"
                @changeSlide="changeSlideComponent"
                :key="update_view_avg_slider_reactions"
              />
            </div>
          </div>

          <!-- Tasa de comenatrios -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('comments_rate')">
                <span class="search-Speach-Bubble-6"></span><strong> {{$t("search.comment_rate")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_comments_rate"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_comments_rate"/>
              </span>              
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_comments_rate">
              <b-form-select
                v-model="comments_rate"
                :options="$t('instaTasaComentarios')"
                :placeholder="$t('search.realty.any')"
              />
            </div>
          </div>

          <!-- Tasa de reacciones -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('reactions_rate')">
                <strong><b-icon class="search-icon" icon="graph-up"/>{{$t("search.reactionRate")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_reactions_rate"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_reactions_rate"/>
              </span>              
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_reactions_rate">
              <b-form-select
                v-model="reactions_rate"
                :options="$t('instaTasaComentarios')"
                :placeholder="$t('search.realty.any')"
              />
            </div>
          </div>

          <!-- Tipo de contenido publicados en los ultimos dias -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('type_content_published')">
                  <div class="d-flex align-items-start">
                    <span>
                      <span class="search-Increasing-Chart1"></span><strong> {{$t("search.type_content_published")}}</strong>
                      <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_type_content_published"/>
                      <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_type_content_published"/>
                    </span>
                    <b-badge pill class="ml-05 badge-blue-filter-searcher-new">{{ $t('newFeature') }}</b-badge>
                  </div>
              </span>              
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_type_content_published">
              <b-form-group class="m-0">
                <b-form-checkbox-group
                  id="checkbox-group-1"
                  v-model="type_content_published"
                  :options="$t('search.filter_youtube_type_content')"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>

          <!-- Aumento de seguidores -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('follower_days')">
                <div class="d-flex align-items-start">
                  <span>
                    <span class="search-Increasing-Chart1"></span><strong> {{$t("search.increaseFollowers")}}</strong>
                    <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_follower_days"/>
                    <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_follower_days"/>
                  </span>
                  <b-badge pill class="ml-05 badge-blue-filter-searcher-new">{{ $t('newFeature') }}</b-badge>
                </div>
              </span>              
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_follower_days">
              <b-form-select
                v-model="followers_days"
                :options="$t('days')"
              />
              <div class="my-1" v-if="followers_days > 0">{{$t("search.increase")}} {{percentage_followers_growth}}%</div>
              <component
                :is="vue_slider"
                :tooltip="'always'"
                class="mt-3"
                v-if="followers_days"
                v-model="percentage_followers_growth"
                :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :max="99"
                :min="1"
                :interval="1"
                @drag-end="changeSlide"
                :tooltip-formatter="'{value}%'"
              />
            </div>
          </div>

          <!-- Brand mentions -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse(18)">
                <div class="d-flex align-items-star">
                  <span>
                    <span class="search-User-Store"></span><strong> {{$t("search.yt.textMentioned")}}</strong>
                    <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_18"/>
                    <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_18"/>
                  </span>
                  <b-badge pill class="ml-05 badge-blue-filter-searcher-new">{{ $t('newFeature') }}</b-badge>
                </div>
              </span>              
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_18">
              <b-form-radio-group
                v-model="mentioned_any"
                :options="$t('search.mentionedBrandOptions')"
                stacked
              ></b-form-radio-group>
            </div>
          </div>

          <!-- Publicación más reciente -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('mentioned_any')">
                <div class="d-flex align-items-start">
                  <span>
                    <span class="search-Calendar"></span><strong> {{$t("search.mostRecent")}}</strong>
                    <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_mentioned_any"/>
                    <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_mentioned_any"/>
                  </span>
                  <b-badge pill class="ml-05 badge-blue-filter-searcher-new">{{ $t('newFeature') }}</b-badge>
                </div>
              </span>              
            </b-form-group>
            <span class="my-1" v-if="most_recent > 0"> {{most_recent}} {{$t("search.days")}}</span>
            <div class="d-none mt-1" ref="collapse_filters_mentioned_any">
              <component
                :is="vue_slider"
                :tooltip="'always'"
                class="mt-3"
                v-model="most_recent_slider"
                :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :max="100"
                :min="0"
                :interval="1"
                @drag-end="changeSlide"
                :tooltip-formatter="() => `${most_recent}`"
              />
              <input
                type="number"
                min="0"
                class="form-control mt-2"
                v-model.number="most_recent"
                @change="changeMostRecentInput"
              />
            </div>
          </div>

          <!-- Recuento de videos -->
          <div class="py-2 border-bottom">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('count_videos')">
                <strong><b-icon class="search-icon" icon="camera-video"/>{{$t("search.countVideos")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_count_videos"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_count_videos"/>
              </span>              
              <div class="my-1" v-if="count_videos > 0">{{count_videos}} {{$t("search.count")}}</div>
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_count_videos">
              <view-avg-slider
                :init_range="count_videos"
                :interval="1000"
                :max_value="20000"
                :min_value="0"
                identifier="count_videos"
                @changeSlide="changeSlideComponent"
                :key="update_view_avg_slider_count_videos"
                ref="view_avg_slider_count_videos"
                :options_numbers="[1000, 5000, 10000, 15000, 20000]"
              />
            </div>
          </div>

          <!-- Puntaje calidad audiencia -->
          <div class="py-2">
            <b-form-group class="mb-0">
              <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('range_views')">
                <strong><b-icon class="search-icon" icon="sort-numeric-up-alt"/>{{$t("search.point_audience")}}</strong>
                <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_range_views"/>
                <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_range_views"/>
              </span>
            </b-form-group>
            <div class="d-none mt-1" ref="collapse_filters_range_views">
              <p class="text-left font-weight-bold m-0">{{quality_audience !== null ? $t(`qualityAudience`).find((item) => item.value === quality_audience).text : $t('search.realty.any')}}</p>
              <options-filters ref="options_filters_gender" :vertical="true" :options="$t('qualityAudience')" @optionsFilter="filterQualityAudience" :key="update_aqs"></options-filters>
            </div>
          </div>
        </b-col> 

      </b-row>
      <template #footer>
        <!-- Button submit -->
        <b-col cols="12" class="button-submit-searcher col-12 mb-3 d-flex flex-wrap">
          <button-submit-filters class="m-1" :searched="searched" :loading="loading" :text="getText()" :total_results="total_results" @sendFilters="sendFilters()" @closeSideBar="closeSideBar()"/>

          <b-button class="m-1" variant="outline-secondary" @click="clearFilters()">
            <b-icon icon="trash" class="cursor-pointer"/>
            {{$t('search.reset_filters')}}
          </b-button>
        </b-col>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BCard, 
  BRow, 
  BCol, 
  BFormGroup, 
  BFormSelect, 
  BButton, 
  BSpinner, 
  BSidebar, 
  BDropdown, 
  BDropdownHeader, 
  BLink, 
  BFormCheckbox, 
  BFormCheckboxGroup,
  BFormRadioGroup,
  BBadge,
  VBTooltip
} from 'bootstrap-vue'
import service from '@/services/search'
import config from '@/services/config'
import { getFiltersUsedLabel, getFormat, numberFormat, separatebycomma } from '@/libs/utils/formats';

export default {
  components: {
    BSidebar,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownHeader,
    BLink,
    BFormCheckbox,
    BBadge,
    BFormCheckboxGroup,
    BFormRadioGroup,
    ChatContact: () => import('@/views/apps/chat/ChatContact.vue'),
    AudienceLocationFilter: () => import('@/views/buscador/filters/audience_locations.vue'),
    FollowersFilter: () => import('@/views/buscador/filters/followers.vue'),
    buttonSubmitFilters: () => import('./buttonSubmitFilters.vue'),
    sliderRange: () => import('./sliderRange.vue'),
    brandSafety: () => import('./filters/brandSafety.vue'),
    applyFilters: () => import('./filters/applyFilters.vue'),
    SearchBy: () => import('@/views/components/inputs/SearchBy.vue'),
    selectNetworkSearch: () => import('./filters/components/selectNetworkSearch.vue'),
    searchByActions: () => import('@/views/buscador/filters/components/searchByActions.vue'),
    OptionsFilters: () => import('@/views/components/button-group/OptionsFilters.vue'),
    viewAvgSlider: () => import('./viewAvgSlider.vue'),
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  props: {
    initial_filters: {
      type: Object,
      default: () => {}
    },
    networks_avaibles: {
      type: Array,
      default: () => {
        return []
      }
    },
    select_network: {
      type: Object,
      default: () => {
        return {}
      }
    },
    filters_history: {
      type: Object,
      default: () => {}
    },
    main_locations_filter: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      getFormat,
      update_view_avg_slider: false,
      update_view_avg_slider_count_videos: false,
      vue_autosuggest: null,
      vue_slider: null,
      update_info_contact: false,
      update_is_verified: false,
      update_aqs: false,
      update_dropdown_categories: false,
      update_followers_filter: false,
      update_location: false,
      update_gender: false,
      open_sidebar: false,
      loading: false,
      total_results: 0,
      input_locations: {
        class: 'form-control',
        placeholder: this.$t("search.typeLocation")
      },
      influencer_category: [],
      influencer_locations: [],
      cancel_influencer_location: null,
      influencer_location: '',
      influencer_language: null,
      is_verified: null,
      has_contacts: null,
      selected_influencer_location: null,
      selected_influencer_locations: [],
      update_influencer_location: false,
      quality_audience: null,
      audience_gender: null,
      percentage_gender: 55,
      audience_ages: [10, 65],
      percentage_audience_age: 10,
      range_views: [10000, 10000000],
      formatter: v => `${numberFormat(v)}`,
      formatter_views: v => `${getFormat(v)}`,
      comments: [0, 10000000],
      update_view_avg_slider_comments: false,
      reactions: [0, 10000000],
      update_view_avg_slider_reactions: false,
      comments_rate: null,
      reactions_rate: null,
      followers_days: null,
      percentage_followers_growth: 50,
      most_recent: 0,
      input_brands: {
        class: 'form-control',
        placeholder: this.$t("search.typeUser")
      },
      cancel_suggests: null,
      count_videos: [0, 20000],
      prices: [0, 1000000],
      role: 'brand',
      loading_location_influencer: false,
      no_locations_influencer: false,
      categories: [],
      category: null,
      typing_timer: null,
      audience_locations: [{}],
      audience_locations_type: [],
      audience_locations_id: [],
      audience_locations_percentage: [],
      text_audience_location: this.$t('search.realty.any'),
      change_audience_location: false,
      text_followers: this.$t('search.realty.any'),
      followers_from: null,
      followers_to: null,
      type_content_published: [],
      filters: [
        {
          filter: 'search_by_influencer',
          text: 'anywhere',
          models: [{name: 'category', value: null, default: ''}],
          update_component: 'update_search_by',
          value: null,
          multiple_values: false
        },
        {
          filter: 'audience_locations',
          text: this.$t("search.audienceLocation"),
          models: [
            {name: 'audience_locations', value: null, default: [{}]},
            {name: 'text_audience_location', value: null, default: this.$t('search.realty.any')}
          ],
          update_component: 'update_location',
          value: null,
          multiple_values: true,
          syntax: [
            {
              type: 'var',
              name: 'name',
            },
            {
              type: 'string',
              name: ' > ',
            },
            {
              type: 'var',
              name: 'percentage'
            },
            {
              type: 'string',
              name: '%',
            },
          ]
        },  
        {
          filter: 'audience_ages',
          text: this.$t("search.audienceAge"),
          models: [
            {name: 'audience_ages', value: null, default: [10, 65]},
            {name: 'percentage_audience_age', value: null, default: 10},
          ],
          value: null,
        },
        {
          filter: 'audience_gender',
          text: this.$t("search.audienceGender"),
          models: [
            {name: 'audience_gender', value: null, default: null},
            {name: 'percentage_gender', value: null, default: 55}
          ],
          update_component: 'update_gender',
          value: null,
        },
        {
          filter: 'quality_audience',
          text: this.$t("search.pointAudience"),
          models: [{name: 'quality_audience', value: null, default: null}],
          update_component: 'update_aqs',
          value: null,
        },
        {
          filter: 'audience_size',
          text: this.$t("search.audienceSize"),
          models: [
            {name: 'followers_from', value: null, default: null},
            {name: 'followers_to', value: null, default: null},
            {name: 'text_followers', value: null, default: this.$t('search.realty.any')},
          ],
          update_component: 'update_followers_filter',
          value: null,
        },
        {
          filter: 'influencer_category',
          text: this.$t("search.category"),
          models: [{name: 'influencer_category', value: null, default: []}],
          update_component: 'update_dropdown_categories',
          multiple_values: true,
          syntax: [
            {
              type: 'var',
              name: 'title',
            },
          ],
          value: null,
        },
        {
          filter: 'influencer_location',
          text: this.$t("search.influencerLocation"),
          models: [
            {name: 'selected_influencer_locations', value: null, default: []},
            {name: 'influencer_location', value: null, default: ''},
            {name: 'selected_influencer_location', value: null, default: null}
          ],
          update_component: 'update_influencer_location',
          value: null,
          multiple_values: true,
          syntax: [
            {
              type: 'var',
              name: 'name',
            },
          ]
        },
        {
          filter: 'influencer_language',
          text: this.$t("search.influencerLanguage"),
          models: [{name: 'influencer_language', value: null}],
          value: null,
        },
        {
          filter: 'is_verified',
          text: this.$t("search.onlyveri"),
          models: [{name: 'is_verified', value: null, default: null}],
          update_component: 'update_is_verified',
          value: null,
        },
        {
          filter: 'info_contact',
          text: this.$t("search.contact"),
          models: [{name: 'has_contacts', value: null, default: null}],
          update_component: 'update_info_contact',
          value: null,
        },
        {
          filter: 'prices',
          text: this.$t("search.priceInfluencer"),
          models: [{name: 'prices', value: null, default: [0, 1000000]},],
          value: null,
        },
        {
          filter: 'average_comments',
          text: this.$t("search.averageComments"),
          models: [{name: 'comments', value: null, default: [0, 10000000]}],
          update_component: 'update_view_avg_slider_comments',
          value: null,
        },
        {
          filter: 'reactions',
          text: this.$t("search.averageReactions"),
          models: [{name: 'reactions', value: null, default: [0, 10000000]}],
          update_component: 'update_view_avg_slider_reactions',
          value: null,
        },
        {
          filter: 'comments_rate',
          text: this.$t("search.comment_rate"),
          models: [{name: 'comments_rate', value: null, default: null}],
          value: null,
        },
        {
          filter: 'reactions_rate',
          text: this.$t("search.reactionRate"),
          models: [{name: 'reactions_rate', value: null, default: null}],
          value: null,
        },
        {
          filter: 'type_content_published',
          text: this.$t("search.type_content_published"),
          models: [{name: 'type_content_published', value: null, default: []}],
          value: null,
          multiple_values: true,
          syntax: [
            {
              type: 'var',
              name: 'title',
            },
          ],
          update_component: 'update_type_content_published'
        },
        {
          filter: 'follower_days',
          text: this.$t("search.increaseFollowers"),
          models: [
            {name: 'followers_days', value: null, default: null},
            {name: 'percentage_followers_growth', value: null, default: 50}
          ],
          value: null,
        },
        {
          filter: 'most_recent',
          text: this.$t("search.mostRecent"),
          models: [{name: 'most_recent', value: null, default: 0}],
          value: null,
        },
        {
          filter: 'count_videos',
          text: this.$t("search.countVideos"),
          models: [{name: 'count_videos', value: null, default: [0, 20000]},],
          value: null,
          update_component: 'update_view_avg_slider_count_videos'
        },
        {
          filter: 'range_views',
          text: this.$t("search.averageViewsVideo"),
          models: [{name: 'range_views', value: null, default: [10000, 10000000]}],
          value: null,
          update_component: 'update_view_avg_slider'
        },
        {
          filter: 'brand_safety',
          text: this.$t("search.brand_safety"),
          models: [{name: 'brand_safety', value: null, default: []}],
          update_component: 'update_brand_safety',
          value: null,
          multiple_values: true,
          syntax: [
            {
              type: 'str_translate',
              name: 'negativeContent',
            },
          ]
        },
        {
          filter: 'engagement_rate',
          text: this.$t("search.engagementRate"),
          models: [{name: 'engagement_rate', value: null, default: 0},],
          value: null,
        },
        {
          filter: 'mentioned_any',
          text: this.$t("search.yt.mentioned"),
          models: [{name: 'mentioned_any', value: null, default: null}],
          value: null,
        }
      ],
      searched: true,
      brand_safety: [],
      update_brand_safety: false,
      update_type_content_published: false,
      engagement_rate: 0,
      mentioned_any: null,
      keywords: [],
      where: 'anywhere',
      update_search_by: false,
      cancel_search_ws: null,
      axios: null,
      loaded_services_history: true,
      total_categories_service: null
    }
  },
  computed: {
    // El slider se limita a 40; el valor real (engagement_rate) puede ser mayor via input
    engagement_rate_slider: {
      get() { return this.engagement_rate > 40 ? 40 : this.engagement_rate },
      set(val) { this.engagement_rate = val }
    },
    // El slider se limita a 100; el valor real (most_recent) puede ser mayor via input
    most_recent_slider: {
      get() { return this.most_recent > 100 ? 100 : this.most_recent },
      set(val) { this.most_recent = val }
    }
  },
  async mounted() {
    this.axios = (await import('axios')).default;
    this.vue_slider = (await import('vue-slider-component')).default;
    this.vue_autosuggest = (await import('vue-autosuggest')).VueAutosuggest
    setTimeout(() => {
      if (this.initial_filters && Object.keys(this.initial_filters).length > 0) {
        this.initialSearch()
      } else if (Object.keys(this.filters_history).length === 0) {
        this.getCounter()
      }
    }, 200);
  },
  created() {
    const userData = JSON.parse(localStorage.getItem('userData'))
    this.role = userData.groups[0].name
    this.getCategories()

    this.searched = true
  },
  methods: {
    updateSelectNetwork(select_network) {
      this.$emit('update_select_network', select_network)
    },
    initialSearch() {
      const filters = {}
      let name_country = '';
      Object.keys(this.initial_filters).forEach((key) => {
        if (key !== 'st') {
          if (key === 'audience_location') {
            filters['audience_location_id'] = [this.initial_filters[key][0].id]
            filters['audience_location_type'] = [this.initial_filters[key][0].type]
            filters['audience_location_from'] = [this.initial_filters[key][0].prc]
            name_country = this.initial_filters[key][0].name
          } else if (key === 'followers_growth') {
            filters['followers_growth_period'] = parseInt(this.initial_filters[key][0].id)
            filters['followers_growth_to'] = this.initial_filters[key][0].prc
          } else if (key === 'audience_gender') {
            filters['audience_gender_id'] = parseInt(this.initial_filters[key][0].id)
            filters['audience_gender_from'] = this.initial_filters[key][0].prc
          } else if (key === 'influencer_category') {
            filters['influencer_yt_category'] = [parseInt(this.initial_filters[key][0].id.replace('2_', ''))]
          } else if (key === 'audience_age') {
            filters['audience_age_from'] = this.initial_filters[key][0].from
            filters['audience_age_p'] = this.initial_filters[key][0].prc
          } else if (key === 'followers') {
            filters['followers_from'] = this.initial_filters[key][0].from
            filters['followers_to'] = this.initial_filters[key][0].to
          } else if (key === 'sort_order') {
            filters[key] = this.initial_filters[key]
          } else if (key === 'sort_type') {
            filters[key] = this.initial_filters[key]
          } else {
            filters[key] = this.initial_filters[key][0].id
          }
        } else {
          filters['st'] = 'yt'
        }
      })

      this.formatApplyFilters(filters, name_country);
      this.$emit('clean_selected');
      this.searched = true

      this.$emit('callYoutube', filters, true)
      this.getCounter(filters)
    },
    formatFiltersHistory(filters) {
      this.loaded_services_history = false;
      this.formatApplyFilters(filters, '')
      this.$emit('callYoutube', filters, true)
      this.getCounter(filters)
    },
    formatApplyFilters(filters, name_country) {
      Object.keys(filters).forEach(key => {
        if (key === 'aqs') {
          const filter = this.filters.find((f) => f.filter === 'quality_audience')
          filter.models[0].value = filters[key]
          filter.value = filters[key]
          this.quality_audience = filters[key];
          const value_aqs = this.$t('qualityAudience').find(i => i.value === filters[key]);
          const key_index_aqs = this.$t('qualityAudience').findIndex((i) => i.value === filters[key])
          if (this.$refs.options_filters_gender) {
            this.$refs.options_filters_gender.valueOptions(value_aqs, key_index_aqs) 
            this.update_aqs = !this.update_aqs;
          }
        } else if (key === 'audience_location_id') {
          const filter = this.filters.find(f => f.filter === 'audience_locations')
          filter.value = `${name_country} ≥ ${filters['audience_location_from']}`

          this.text_audience_location = filters['audience_location_text'] ? filters['audience_location_text'] : this.$t('search.realty.any')
          const country = this.text_audience_location.split(',').slice(0, -1)
          filter.models[0].value = [{id: filter[key], name: name_country.length === 0 ? country.join(', ') : name_country, percentage: filters['audience_location_from'], type: filters['audience_location_type']}]
        } else if (key === 'followers_growth_to') {
          const filter = this.filters.find(f => f.filter === 'follower_days')
          const period = parseInt(filters['followers_growth_period'])
          filter.models[0].value = period
          filter.models[1].value = filters[key]
          this.followers_days = filters['followers_growth_period'];
          this.percentage_followers_growth = filters['followers_growth_to']
          filter.value = `${this.$t('days').find((item) => item.value === period).text}, ${filters[key]}%`
        } else if (key === 'audience_gender_id') {
          const gender_text = this.$t('instaGen').find(g => g.value === filters['audience_gender_id'])

          this.audience_gender = this.$t('instaGen').find((i) => i.value === filters['audience_gender_id'])
          const percentage_gender = filters[key]
          this.percentage_gender = percentage_gender;
          const new_models = [{name: 'audience_gender', value: filters['audience_gender_id']}]
          this.changeFilter('audience_gender', new_models, `${gender_text.text}, ≥${percentage_gender}%`)
          
          const key_index = this.$t('instaGen').findIndex((i) => i.value === this.audience_gender.value)
          this.setAudienceGender(this.audience_gender, key_index)
          this.update_gender = !this.update_gender;
        } else if (key === 'influencer_yt_category') {
          if (this.categories.length === 0) {
            setTimeout(() => {
              const cat = this.categories.find((item) => item.id === filters[key][0])
              this.influencer_category.push(cat);
              const new_models = [{name: 'influencer_category', value: this.influencer_category}];
              this.changeFilter('influencer_category', new_models, this.influencer_category.length !== 0 ? this.influencer_category[0].title : null);
            }, 1000)
          } else {
            const cat = this.categories.find((item) => item.id === filters[key][0])
            this.influencer_category.push(cat);
            const new_models = [{name: 'influencer_category', value: this.influencer_category}];
            this.changeFilter('influencer_category', new_models, this.influencer_category.length !== 0 ? this.influencer_category[0].title : null);
          }
        } else if (key === 'followers_from') {
          const filter = this.filters.find(f => f.filter === 'audience_size')
          filter.models[0].value = filters[key]
          filter.models[1].value = filters['followers_to']
          filter.value = `${getFormat(filters[key])}-${getFormat(filters['followers_to'])}`

          this.followers_from = filters[key]
          this.followers_to = filters['followers_to']
          this.update_followers_filter = !this.update_followers_filter

          if (this.followers_from && this.followers_to) {
            this.text_followers = `${getFormat(this.followers_from)}-${getFormat(this.followers_to)}`
          } else if (this.followers_from) {
            this.text_followers = `≥${getFormat(this.followers_size[0])}`
          } else if (this.followers_to) {
            this.text_followers = `≤${getFormat(this.followers_size[1])}`
          }
        } else if (key === 'audience_age_from') {
          this.percentage_audience_age = filters['audience_age_p']
          this.audience_ages = [filters['audience_age_from'] ? filters['audience_age_from'] : 10, filters['audience_age_to'] ? filters['audience_age_to'] : 65];
          const new_models = [{name: 'audience_ages', value: filters['audience_age_p']}]
          this.changeFilter('audience_ages', new_models, this.getAudienceAge())
        } else if (key === 'category') {
          const new_models = [{name: 'category', value: filters[key]}];
          this.addKeywordFilter(new_models, filters[key], {category: true})
        } else if (key === 'keywords') {
          filters[key].forEach((i, index) => {
            this.filters.push(
              {
                filter: `search_by_keywords_${index}`,
                text: this.$t(`search.${i.type_keyword}`),
                models: [{name: 'keywords', value: 'fdsa', default: ''}],
                value: i.keyword,
                multiple_values: false
              },
            )            
          })
        } else if (key === 'influencer_location_id') {
          const filter = this.filters.find(f => f.filter === 'influencer_location')
          const ids = Array.isArray(filters['influencer_location_id']) ? filters['influencer_location_id'] : [filters['influencer_location_id']]
          const types = Array.isArray(filters['influencer_location_type']) ? filters['influencer_location_type'] : [filters['influencer_location_type']]
          const names = filters['influencer_location_text'] ? filters['influencer_location_text'].split(' | ') : []
          const locations = ids.map((id, i) => ({id, type: types[i], name: names[i] !== undefined ? names[i] : `${id}`}))
          this.selected_influencer_locations = locations
          filter.models[0].value = locations
          filter.value = locations.length > 0 ? `${locations[0].name}${locations.length > 1 ? ` +${locations.length - 1}` : ''}` : null
          this.influencer_location_id = filters['influencer_location_id'];
          this.influencer_location_type = filters['influencer_location_type']
        } else if (key === 'influencer_language' || key === 'is_verified' || key === 'has_contacts') {
          const key_filter = key !== 'has_contacts' ? key : 'info_contact';
          const filter = this.filters.find((f) => f.filter === key_filter)
          filter.models[0].value = filters[key]
          filter.value = filters[key]
          this[key] = filters[key];
        } else if (key === 'blogger_prices_from' || key === 'blogger_prices_to') {
          const filter = this.filters.find(f => f.filter === 'prices')
          filter.models[0].value = [
            filters['blogger_prices_from'] ? filters['blogger_prices_to'] : filter.models[0].default[0],
            filters['blogger_prices_to'] ? filters['blogger_prices_to'] : filter.models[0].default[1]
          ];
          this.prices = [
            filters['blogger_prices_from'] ? filters['blogger_prices_from'] : filter.models[0].default[0],
            filters['blogger_prices_to'] ? filters['blogger_prices_to'] : filter.models[0].default[1]
          ]
        } else if (key === 'brand_safety') {
          const filter = this.filters.find((f) => f.filter === 'brand_safety')
          filter.models[0].value = filters[key]
          this.brand_safety = filters[key];
        } else if (key === 'has_content_type') {
          const filter = this.filters.find((f) => f.filter === 'type_content_published')
          filter.models[0].value = filters[key]
          this.type_content_published = filters[key];
        } else if (key === 'er') {
          this.engagement_rate = filters[key]
        } else if (key === 'yt_comments_from' || key === 'yt_comments_to') {
          this.applyRangeFilter(filters, 'average_comments', 'yt_comments_from', 'yt_comments_to', 'comments', 'view_avg_slider_comments')
        } else if (key === 'yt_reactions_from' || key === 'yt_reactions_to') {
          this.applyRangeFilter(filters, 'reactions', 'yt_reactions_from', 'yt_reactions_to', 'reactions', 'view_avg_slider_reactions')
        } else if (key === 'yt_recent_video_to') {
          this.most_recent = filters[key]
        } else if (key === 'yt_videos_from' || key === 'yt_videos_to') {
          this.applyRangeFilter(filters, 'count_videos', 'yt_videos_from', 'yt_videos_to', 'count_videos', 'view_avg_slider_count_videos')
        } else if (key === 'mentioned_any') {
          this[key] = filters[key]
        } else if (key === 'comments_rate') {
          const filter = this.filters.find(f => f.filter === 'average_comments')
          filter.models[0].value = filters['comments_rate']
          filter.value = this.$t('instaTasaComentarios').find((item) => item.value === filters['comments_rate']).text
          this.comments_rate = filters['comments_rate']
        } else if (key === 'yt_reactions_rate') {
          const filter = this.filters.find(f => f.filter === 'reactions_rate')
          filter.models[0].value = filters['yt_reactions_rate']
          filter.value = this.$t('instaTasaComentarios').find((item) => item.value === filters['yt_reactions_rate']).text
          this.reactions_rate = filters['yt_reactions_rate']
        } else if (key === 'yt_views_from' || key === 'yt_views_to') {
          this.applyRangeFilter(filters, 'range_views', 'yt_views_from', 'yt_views_to', 'range_views', 'view_avg_slider')
        }
      })
    },
    filterQualityAudience(options) {
      this.quality_audience = options.value
    },
    filterVerified(options) {
      this.is_verified = options.value
    },
    filterHasContacts(options) {
      this.has_contacts = options.value
    },
    addKeywordFilter(new_models, keywords, where = {}) {
      if (where.category) { 
        this.keywords = [];
        this.filters = this.filters.filter((i) => !i.filter.includes('search_by_keywords'))
        this.$refs.search_by_actions.$refs.search_by_category.keywords_array = [];
        this.category = keywords;

        if (keywords.length === 0) {
          new_models[0].value = null;
        } else {
          const filter = this.filters.find(i => i.filter === 'search_by_influencer')
          filter.text = this.$t('search.category');
          this.changeFilter('search_by_influencer', new_models, keywords);
        }
  
        clearTimeout(this.typing_timer);
        this.typing_timer = setTimeout(this.getCounterInputHandleIt, 500);
      } else {
        this.keywords = keywords;
        this.category = null;
        this.getCounter();
        
        if (where.tag_deleted !== null) this.filters = this.filters.filter((i) => i.value !== where.tag_deleted);
        if (where.deleted_all) this.filters = this.filters.filter((i) => !i.filter.includes('search_by_keywords'))
        keywords.forEach((i, index) => {
          if (!this.filters.find(j => j.value === i.keyword)) {
            this.filters.push(
              {
                filter: `search_by_keywords_${index}`,
                text: this.$t(`search.${i.type_keyword}`),
                models: [{name: 'keywords', value: null, default: ''}],
                value: null,
                multiple_values: false
              },
            )
            this.changeFilter(`search_by_keywords_${index}`, new_models, i.keyword);
          }
        })
      }
    },
    getCounterInputHandleIt(prev_filters = false) {
      this.searched = false
      const filters = prev_filters ? prev_filters : this.getFilters()
      filters.counter = 1;

      service.saveLogSearch(filters)
        .then(() => {
        })
      this.loading = true;
      this.total_results = 0

      const CancelToken = this.axios.CancelToken;
      if (this.cancel_search_ws) this.cancel_search_ws()
      const self = this;
      this.axios({
        method: 'post',
        url: `${config.urlPhp}/api/v1/buscador/influencers`,
        headers: { 'brandme-key': process.env.VUE_APP_BRANDME_KEY },
        data:{
          ...filters
        },
        cancelToken: new CancelToken(function executor(c) {
          self.cancel_search_ws = c;
        })
      }).then((response) => {
        this.total_results = response.data.data.total ? response.data.data.total : 0
        this.loading = false;
      })
    },
    changeInfluencerCategory(category, id_deleted) {
      const new_models = [{name: 'influencer_category', value: category}];
      this.$refs[`word_item_category_${id_deleted}`][0].classList.remove('word-break');
      this.$refs[`check_item_category_${id_deleted}`][0].classList.add('d-none');
      this.changeFilter('influencer_category', new_models, null);
      this.getCounter();
    },
    addCategoryFilter(category) {
      if (this.influencer_category.find((item) => item.id === category.id) === undefined) {
        this.influencer_category.push(category);
        const new_models = [{name: 'influencer_category', value: this.influencer_category}];
        this.changeFilter('influencer_category', new_models, this.influencer_category.length !== 0 ? this.influencer_category[0].title : null);
        this.getCounter();
        this.$refs[`word_item_category_${category.id}`][0].classList.add('word-break');
        this.$refs[`check_item_category_${category.id}`][0].classList.remove('d-none');
      } else {
        this.influencer_category.forEach((item,i) => { if (item.id === category.id) this.influencer_category.splice(i,1) })
        this.$refs[`word_item_category_${category.id}`][0].classList.remove('word-break');
        this.$refs[`check_item_category_${category.id}`][0].classList.add('d-none');
        this.getCounter();
      }     
    },
    deleteFilter(name, get_counter = true) {
      const to_deleted = this.filters.find((item) => item.filter === name);
      if (name.includes('search_by_keywords')) {
        this.$refs.search_by_actions.$refs.search_by_category.keywords_array = this.$refs.search_by_actions.$refs.search_by_category.keywords_array.filter(i => i.keyword !== to_deleted.value)
        this.keywords = this.keywords.filter(i => i.keyword !== to_deleted.value)
      }
      to_deleted.models.forEach((item) => {
        if (!name.includes('search_by_keywords')) this[item.name] = item.default;
        if (item.name === 'influencer_category') item.default = []
        item.value = null;
      });
      if (to_deleted.update_component) this[to_deleted.update_component] = !this[to_deleted.update_component];
      to_deleted.value = null;
      this.closeCollapse(to_deleted.filter);
      if (get_counter) this.getCounter();
      this.searched = true;
      
      if (name.includes('search_by_keywords')) this.filters = this.filters.filter(i => i.filter !== name)
    },
    closeCollapse(id) {
      if (this.$refs[`collapse_filters_${id}`]) {
        this.$refs[`collapse_filters_${id}`].classList.contains('d-none') ? '' : this.$refs[`collapse_filters_${id}`].classList.add('d-none');
        this.$refs[`chev_up_${id}`].classList.add('d-none');
        this.$refs[`chev_down_${id}`].classList.contains('d-none') ? this.$refs[`chev_down_${id}`].classList.remove('d-none') : '';
      }
    },
    checkFiltersUsed() {
      return this.filters.filter((item) => item.models[0].value !== null);
    },
    clearFilters(loading_results = true, send_service = true) {
      this.filters.forEach(item => {
        this.deleteFilter(item.filter, false)
      })
      if (send_service) {
        this.sendFilters(loading_results);
        this.getCounter();
      }

      this.searched = true
      this.open_sidebar = false;
    },
    toggleCollapse(id) {
      if (this.$refs[`collapse_filters_${id}`]) {
        this.$refs[`collapse_filters_${id}`].classList.toggle('d-none');
        this.$refs[`chev_down_${id}`].classList.toggle('d-none');
        this.$refs[`chev_up_${id}`].classList.toggle('d-none');
      }
    },
    getAudienceAge() {
      const paragraph = `, ≥ ${this.percentage_audience_age}%`;
      let first = '';
      if (this.audience_ages[1] === 65) first = `≥ ${this.audience_ages[0]}`
      else if (this.audience_ages[0] === 10)  first = `≤ ${this.audience_ages[1]}`
      else first = `${this.audience_ages[0]} - ${this.audience_ages[1]}`;
      return first + paragraph;
    },
    setAudienceGender(gender, index) {
      this.audience_gender = gender;
      this.$refs.gender_dropdown.map((item, i) => {
        if (i === index) item.classList.add('background-clicked-form');
        else item.classList.remove('background-clicked-form');
      });
    },
    getCategories() {
      service.getCategories('youtube')
        .then(response => {
          this.total_categories_service = response;
          response.categories.forEach(cat => {
            const category = {
              id: cat.id,
              title: this.$t(`filters.${cat.title}`)
            }
            this.categories.push(category)
          });
          this.categories.sort((a, b) => (a.title < b.title ? -1 : 1));
        })
        .catch(() => {
        })
    },
    getText() {
      if (this.loading) return this.$t("search.searching")
      if ((this.total_results > 0 && this.searched) || !this.searched) return this.$t('search.showResults', { count: getFormat(this.total_results) })
      return this.$t('search.noResults')
    },
    getRange(min, max, model) {
      // El extremo se omite solo si esta en su limite (min/max). Valores por encima
      // del max (cuando el slider permite no_max_limit) se envian tal cual.
      return {
        from: this[model][0] > min ? this[model][0] : null,
        to: this[model][1] !== max ? this[model][1] : null
      }
    },
    getCounter (prev_filters = false) {
      this.searched = false
      const filters = prev_filters ? prev_filters : this.getFilters()
      filters.counter = 1;

      service.saveLogSearch(filters)
        .then(() => {
        })

      this.loading = true;
      this.total_results = 0
      service.getResults(filters)
        .then(response => {
          if (Object.keys(this.filters_history).length > 0) this.loaded_services_history = true;
          this.total_results = response.data.total
          this.loading = false;
        }).catch(() => {
          this.total_results = 0
          this.loading = false;
        })
    },
    addAudienceLocation() {
      this.audience_locations.push({})
    },
    removeAudienceLocation(location, index, force_remove = false, from_filters = false) {
      const self = this
      setTimeout(function() {
        const is_show = self.$refs.filter_audience_location.$el.querySelector('ul').classList.contains('show')
        if (!from_filters && !is_show && force_remove) self.$refs.filter_audience_location.$el.querySelector('button').click()
      }, 15)

      if (force_remove) this.audience_locations.splice(index, 1)
      else this.audience_locations[index] = {}

      if (!location) return

      if (this.audience_locations.length === 0) {
        this.deleteFilter('audience_locations')
        this.text_audience_location = this.$t('search.realty.any')
      } else {
        let counter_empty = 0
        const location_length = this.audience_locations.filter((item) => item.id).length
        this.audience_locations.map((item) => {
          if (item.id) {
            const additional_text = location_length > 1 ? `+${location_length - 1}` : ''
            this.text_audience_location = `${item.name}, ≥${item.percentage}% ${additional_text}`
          } else {
            counter_empty += 1;
          }
          if (this.audience_locations.length === counter_empty) {
            this.deleteFilter('audience_locations')
            this.text_audience_location = this.$t('search.realty.any')
          }
        });
      }

      this.update_location = !this.update_location
      this.getCounter()
    },
    changeLocationAudience(data) {
      const index = data.key
      this.audience_locations[index].id = data.location.id
      this.audience_locations[index].type = data.location.type
      this.audience_locations[index].name = data.location.name
      this.audience_locations[index].percentage = data.percentage

      const location_length = this.audience_locations.filter((item) => item.id).length;

      this.audience_locations.map((item) => {
        if (item.id) {
          const additional_text = location_length > 1 ? `+${location_length - 1}` : '';
          this.text_audience_location = `${item.name}, ≥${item.percentage}% ${additional_text}`;
        }
      });
      const new_models = [{name: 'audience_locations', value: this.audience_locations}]
      this.changeFilter('audience_locations', new_models, this.text_audience_location)
      this.getCounter()
    },
    changeFollowers(data) {
      this.followers_from = data.from
      this.followers_to = data.to
      let value_model = data.from + data.to
      if (this.followers_from && this.followers_to) {
        this.text_followers = `${getFormat(this.followers_from)}-${getFormat(this.followers_to)}`
      } else if (this.followers_from) {
        this.text_followers = `≥${getFormat(this.followers_from)}`
      } else if (this.followers_to) {
        this.text_followers = `≤${getFormat(this.followers_to)}`
      } else {
        value_model = null
        this.text_followers = this.$t('search.realty.any')
      }
      const new_models = [
        {name: 'followers_from', value: value_model},
        {name: 'followers_to', value: this.followers_to},
      ]
      this.changeFilter('audience_size', new_models, this.text_followers)
      this.getCounter()
    },
    formatAudienceLocations() {
      this.audience_locations_id = []
      this.audience_locations_type = []
      this.audience_locations_percentage = []
      if (this.audience_locations.length > 0) {
        this.audience_locations.forEach(location => {
          if (location.id) {
            this.audience_locations_id.push(location.id)
            this.audience_locations_type.push(location.type)
            this.audience_locations_percentage.push(location.percentage)
          }
        })
      }
    },
    getFilters () {
      const finalFilters = {}
      const audience_ages = this.getRange(10, 65, 'audience_ages');
      const views = this.getRange(10000, 10000000, 'range_views');
      const prices = this.getRange(0, 1000000, 'prices');
      const count_videos = this.getRange(0, 20000, 'count_videos');
      const comments = this.getRange(0, 10000000, 'comments');
      const reactions = this.getRange(0, 10000000, 'reactions');
      
      this.formatAudienceLocations()

      const data = {
        hash: localStorage.getItem('accessToken'),
        st: 'yt',
        keywords: this.keywords.length !== 0 ? this.keywords : null,
        // influencer_yt_category: this.influencer_category.length !== 0 ? this.influencer_category.map((item) => item.id) : null,
        influencer_yt_category: this.category ? [this.categories.find(i => i.title === this.category).id] : null,
        where: this.where === 'anywhere' ? null : this.where,
        followers_from: this.followers_from,
        followers_to: this.followers_to,
        influencer_location_id: this.selected_influencer_locations.length > 0 ? this.selected_influencer_locations.map((item) => item.id) : null,
        influencer_location_type : this.selected_influencer_locations.length > 0 ? this.selected_influencer_locations.map((item) => item.type) : null,
        influencer_location_text: this.selected_influencer_locations.length > 0 ? this.selected_influencer_locations.map((item) => item.name).join(' | ') : null,
        influencer_language: this.influencer_language,
        is_verified: this.is_verified,
        has_contacts: this.has_contacts,
        aqs: this.quality_audience,
        audience_location_id: this.audience_locations_id.length > 0 ? this.audience_locations_id : null,
        audience_location_type: this.audience_locations_type.length > 0 ? this.audience_locations_type : null,
        audience_location_from: this.audience_locations_percentage.length > 0 ? this.audience_locations_percentage : null,
        audience_location_text: this.text_audience_location !== this.$t('search.realty.any') ? this.text_audience_location : null,
        audience_gender_id: this.audience_gender ? this.audience_gender.value : null,
        audience_gender_from: this.audience_gender ? this.percentage_gender : null,
        audience_age_from: audience_ages.from,
        audience_age_to: audience_ages.to,
        audience_age_p: this.showPercentageAgeAudience() ? this.percentage_audience_age : null,
        yt_views_from: views.from,
        yt_views_to: views.to,
        yt_comments_from: comments.from,
        yt_comments_to: comments.to,
        yt_reactions_from: reactions.from,
        yt_reactions_to: reactions.to,
        comments_rate: this.comments_rate,
        yt_reactions_rate: this.reactions_rate,
        followers_growth_period: this.followers_days,
        followers_growth_to: this.followers_days ? this.percentage_followers_growth : null,
        yt_recent_video_to: this.most_recent > 0 ? this.most_recent : null,
        yt_videos_from: count_videos.from,
        yt_videos_to: count_videos.to,
        blogger_prices_from: prices.from,
        has_content_type: this.type_content_published.length > 0 ? this.type_content_published : null,
        blogger_prices_to: prices.to,
        brand_safety: this.brand_safety.length > 0 ? this.brand_safety : null,
        er: this.engagement_rate > 0 ? this.engagement_rate : null,
        mentioned_any: this.mentioned_any !== null ? this.mentioned_any : null,
        total_results: this.total_results,
        filters_label_used: getFiltersUsedLabel(this.filters)
      }
      const dataKeys = Object.keys(data)
      for (let i = 0; i < dataKeys.length; i++) {
        const dataKey = dataKeys[i]
        if (data[dataKey] !== null) {
          finalFilters[dataKey] = data[dataKey]
        }
      }
      return finalFilters
    },
    sendFilters (loading_results = true) {
      this.searched = true
      const finalFilters = this.getFilters()
      this.$emit('callYoutube', finalFilters, loading_results)
      this.$emit('clean_selected');
    },
    closeSideBar() {
      this.open_sidebar = false
    },
    shouldRenderSuggestions (size, loading) {
      return size >= 0 && !loading
    },
    inputInfluencerLocation (text) {
      this.influencer_locations = []
      this.no_locations_influencer = false;
      if (text !== '') {
        this.loading_location_influencer = true;
        const CancelToken = this.axios.CancelToken;

        if (this.cancel_influencer_location) this.cancel_influencer_location()

        const self = this;
        this.axios({
          method: 'post',
          url: `${config.urlPhp}/api/v1/ubicaciones`,
          data:{
            query: text
          },
          headers: {
            'brandme-key': process.env.VUE_APP_BRANDME_KEY,
          },
          cancelToken: new CancelToken(function executor(c) {
            self.cancel_influencer_location = c;
          })
        })
          .then(result => {
            const { countries } = result.data.data
            self.datasuggest = [...countries.map(country => ({id:country.geonameid, name:country.name, type: 0}))]
            const filteredData = self.datasuggest
            this.no_locations_influencer = filteredData.length < 1;
            this.loading_location_influencer = false;
            self.influencer_locations = [{data: filteredData}]
          })
          .catch(error => {
            if (this.axios.isCancel(error)) {
              console.log('');
            } else {
              this.no_locations_influencer = true;
              this.loading_location_influencer = false;
            }
            return []
          });
      }
    },
    getInfluencerLocation (suggestion) {
      const location = suggestion.item
      const already_added = this.selected_influencer_locations.some((item) => item.id === location.id)
      if (!already_added && this.selected_influencer_locations.length < 5) {
        this.selected_influencer_locations.push({id: location.id, name: location.name, type: location.type})
        this.updateInfluencerLocationsFilter()
        this.getCounter()
      }
      this.influencer_location = ''
      this.influencer_locations = []
      return ''
    },
    removeInfluencerLocation(index) {
      this.selected_influencer_locations.splice(index, 1)
      if (this.selected_influencer_locations.length === 0) {
        this.deleteFilter('influencer_location')
      } else {
        this.updateInfluencerLocationsFilter()
        this.getCounter()
      }
    },
    changeInfluencerLocationsList(locations) {
      this.selected_influencer_locations = locations
      if (this.selected_influencer_locations.length === 0) {
        this.deleteFilter('influencer_location')
      } else {
        this.updateInfluencerLocationsFilter()
        this.getCounter()
      }
    },
    updateInfluencerLocationsFilter() {
      const new_models = [{name: 'selected_influencer_locations', value: this.selected_influencer_locations}]
      const first = this.selected_influencer_locations[0]
      const additional = this.selected_influencer_locations.length > 1 ? ` +${this.selected_influencer_locations.length - 1}` : ''
      this.changeFilter('influencer_location', new_models, first ? `${first.name}${additional}` : null)
      this.update_influencer_location = !this.update_influencer_location
    },
    changeSlide() {
      this.getCounter()
    },
    changeEngagementInput() {
      let val = parseFloat(this.engagement_rate)
      if (isNaN(val) || val < 0) val = 0
      this.engagement_rate = val
      if (this.loaded_services_history) this.getCounter()
    },
    changeMostRecentInput() {
      let val = parseInt(this.most_recent)
      if (isNaN(val) || val < 0) val = 0
      this.most_recent = val
      if (this.loaded_services_history) this.getCounter()
    },
    getLabelAgeAudience() {
      if (this.audience_ages[0] === 10 && this.audience_ages[1] === 65) return this.$t("search.anyAge")
      if (this.audience_ages[0] !== 10 && this.audience_ages[1] !== 65) return `${this.$t("search.between")} ${this.audience_ages[0]} ${this.$t("search.and")} ${this.audience_ages[1]}`
      if (this.audience_ages[0] > 10) return `${this.$t("search.lessThan")} ${this.audience_ages[0]}`
      if (this.audience_ages[1] < 65) return `${this.$t("search.greaterThan")} ${this.audience_ages[1]}`

      return this.$t("search.anyAge")
    },
    changeSlideComponent(identifier, new_range) {
      this[identifier] = new_range
      this.getCounter()
        
      // For a strange reason this conditional shouldn´t be here, 
      // but this language is javascript and it is the only way it works!
      if (identifier === 'range_views') {
        const new_models = [{name: 'range_views', value: new_range[0] === 10000 && new_range[1] === 10000000 ? null : new_range}]
        this.changeFilter('range_views', new_models, new_range[0] === 10000 && new_range[1] === 10000000 ? null : this.getLabelViews())
      }
      if (identifier === 'comments') {
        const new_models = [{name: 'comments', value: new_range[0] === 0 && new_range[1] === 10000000 ? null : new_range}]
        this.changeFilter('average_comments', new_models, new_range[0] === 0 && new_range[1] === 10000000 ? null : this.getLabelComments())
      }
      if (identifier === 'reactions') {
        const new_models = [{name: 'reactions', value: new_range[0] === 0 && new_range[1] === 10000000 ? null : new_range}]
        this.changeFilter('reactions', new_models, new_range[0] === 0 && new_range[1] === 10000000 ? null : this.getLabelReactions())
      }
      // ============================================================================================
    },
    showPercentageAgeAudience() {
      if (this.audience_ages[0] === 10 && this.audience_ages[1] === 65) return false
      return true
    },
    getLabelRange(range, min_default, max_default, formatter, any_key) {
      const lo = Number(range[0])
      const hi = Number(range[1])
      if (lo === min_default && hi === max_default) return this.$t(any_key)
      if (lo !== min_default && hi !== max_default) return `${this.$t("search.between")} ${formatter(range[0])} ${this.$t("search.and")} ${formatter(range[1])}`
      if (lo !== min_default) return `${this.$t("search.from")} ${formatter(range[0])}`
      if (hi !== max_default) return `${this.$t("search.to")} ${formatter(range[1])}`
      return this.$t(any_key)
    },
    getLabelPrices() {
      return this.getLabelRange(this.prices, 0, 1000000, v => `$${numberFormat(v)}`, 'search.anyPrice')
    },
    getLabelViews() {
      return this.getLabelRange(this.range_views, 10000, 10000000, getFormat, 'search.anyQuantity')
    },
    getLabelComments() {
      return this.getLabelRange(this.comments, 0, 10000000, getFormat, 'search.anyQuantity')
    },
    getLabelReactions() {
      return this.getLabelRange(this.reactions, 0, 10000000, getFormat, 'search.anyQuantity')
    },
    changeBrandSafety(brand_safety) {
      this.brand_safety = brand_safety
      const value = brand_safety.length === 0 ? null : this.$t(`negativeContent.${brand_safety[0]}`)
      const new_models = [{name: 'brand_safety', value: brand_safety.length === 0 ? null : brand_safety}]
      this.changeFilter('brand_safety', new_models, brand_safety.length > 1 ? `${value} +${brand_safety.length - 1}` : value)
      this.getCounter()
    },
    changeFilter(name_filter, new_models, value_filter) {
      const filter = this.filters.find(item => item.filter === name_filter)

      filter.models.forEach(model => {
        const new_model = new_models.find(mod => mod.name === model.name)

        if (new_model) {
          model.value = new_model.value
        }
      })
      filter.value = value_filter
    },
    applyRangeFilter(filters, filter_name, from_key, to_key, data_name, slider_ref) {
      const filter = this.filters.find(f => f.filter === filter_name)
      const range = [
        filters[from_key] ? filters[from_key] : filter.models[0].default[0],
        filters[to_key] ? filters[to_key] : filter.models[0].default[1]
      ];
      filter.models[0].value = range;
      this[data_name] = range;
      const view_avg_slider_component = this.$refs[slider_ref]
      if (view_avg_slider_component) {
        view_avg_slider_component.range = range
      }
    },
    updateModel(data) {
      if (data.name_emit) {
        this[data.name_emit](...data.params)
      }
    }
  },
  watch: {
    loading(val) {
      this.$emit('change_loading', val);
    },
    '$i18n.locale'() {
      this.input_locations = {
        class: 'form-control',
        placeholder: this.$t("search.typeLocation")
      }
      this.input_brands = {
        class: 'form-control',
        placeholder: this.$t("search.typeUser")
      }

      if (this.audience_locations.length === 1 && !this.audience_locations[0].id) {
        this.text_audience_location = this.$t('search.realty.any')
      }
    },
    initial_filters(val) {
      if (Object.keys(val).length > 0) this.initialSearch()
    },
    type_content_published(val) {
      const value_text = val.length === 0 ? null : this.$t('search.filter_youtube_type_content').find((item) => item.value === val[0]).text
      const new_models = [{name: 'type_content_published', value: val.length === 0 ? null : val}]
      this.changeFilter('type_content_published', new_models, val.length > 1 ? `${value_text} +${val.length - 1}` : value_text)
      if (this.loaded_services_history) this.getCounter()
    },
    filters_history(val, old_val) {
      this.clearFilters(true, false);
      if (val && Object.keys(val).length > 0 && (JSON.stringify(val) !== JSON.stringify(old_val))) {
        this.formatFiltersHistory(val, '')
      }
    },
    influencer_language(val) {
      const new_models = [{name: 'influencer_language', value: val ? this.$t('instaIdioma').find((item) => item.value === val).value : null}]
      this.changeFilter('influencer_language', new_models, val ? this.$t('instaIdioma').find((item) => item.value === val).text : null)
      if (this.loaded_services_history) this.getCounter()
    },
    is_verified(val) {
      const new_models = [{name: 'is_verified', value: this.$t('instaVerificado').find((item) => item.value === val).value}]
      this.changeFilter('is_verified', new_models, this.$t('instaVerificado').find((item) => item.value === val).text)
      if (this.loaded_services_history) this.getCounter()
    },
    has_contacts(val) {
      const new_models = [{name: 'has_contacts', value: this.$t('instaContacto').find((item) => item.value === val).value}]
      this.changeFilter('info_contact', new_models, this.$t('instaContacto').find((item) => item.value === val).text)
      if (this.loaded_services_history) this.getCounter()
    },
    quality_audience(val) {
      const new_models = [{name: 'quality_audience', value: this.$t('qualityAudience').find((item) => item.value === val).value}]
      this.changeFilter('quality_audience', new_models, this.$t('qualityAudience').find((item) => item.value === val).text)
      if (this.loaded_services_history) this.getCounter()
    },
    audience_gender(val) {
      const new_models = [{name: 'audience_gender', value: val ? val.value : null}]
      if (val && val.value === null) {
        new_models.push({name: 'percentage_gender', value: 55})
        this.percentage_gender = 55;
      }
      this.changeFilter('audience_gender', new_models, val ? `${val.text}, ≥${this.percentage_gender}%` : null)
      if (this.loaded_services_history) this.getCounter()
    },
    percentage_gender(val) {
      this.changeFilter('audience_gender', [], this.audience_gender ? `${this.audience_gender.text}, ≥${val}%` : null)
    },
    prices(val) {
      const new_models = [{name: 'prices', value: val[0] === 0 && val[1] === 1000000 ? null : val}]
      this.changeFilter('prices', new_models, val[0] === 0 && val[1] === 1000000 ? null : this.getLabelPrices())
    },
    comments_rate(val) {
      const new_models = [{name: 'comments_rate', value: this.$t('instaTasaComentarios').find((item) => item.value === val).value}]
      this.changeFilter('comments_rate', new_models, this.$t('instaTasaComentarios').find((item) => item.value === val).text)
      if (this.loaded_services_history) this.getCounter()
    },
    audience_ages(val) {
      const new_models = [{name: 'audience_ages', value: val[0] !== 10 || val[1] !== 65 ? val : null}]
      this.changeFilter('audience_ages', new_models, val[0] !== 10 || val[1] !== 65 ? this.getAudienceAge() : this.$t('search.realty.any'))

      if (val[0] === 10 && val[1] === 65) {
        this.percentage_audience_age = 10;
      }
    },
    percentage_audience_age() {
      this.changeFilter('audience_ages', [], this.getAudienceAge())
    },
    comments(val) {
      const new_models = [{name: 'comments', value: val[0] === 0 && val[1] === 10000000 ? null : val}]
      this.changeFilter('average_comments', new_models, val[0] === 0 && val[1] === 10000000 ? null : this.getLabelComments())
    },
    reactions(val) {
      const new_models = [{name: 'reactions', value: val[0] === 0 && val[1] === 10000000 ? null : val}]
      this.changeFilter('reactions', new_models, val[0] === 0 && val[1] === 10000000 ? null : this.getLabelReactions())
    },
    reactions_rate(val) {
      const new_models = [{name: 'reactions_rate', value: this.$t('instaTasaComentarios').find((item) => item.value === val).value}]
      this.changeFilter('reactions_rate', new_models, this.$t('instaTasaComentarios').find((item) => item.value === val).text)
      if (this.loaded_services_history) this.getCounter()
    },
    followers_days(val) {
      const new_models = [{name: 'followers_days', value: this.$t('days').find((item) => item.value === val).value}]
      this.changeFilter('follower_days', new_models, `${this.$t('days').find((item) => item.value === val).text}, ${this.percentage_followers_growth}%`)
      if (this.loaded_services_history) this.getCounter()
    },
    percentage_followers_growth(val) {
      this.changeFilter('follower_days', [], `${this.$t('days').find((item) => item.value === this.followers_days).text}, ${val}%`)
    },
    most_recent(val) { 
      const new_models = [{name: 'most_recent', value: val !== 0 ? val : null}]
      this.changeFilter('most_recent', new_models, val !== 0 ? val : null)
    },
    count_videos(val) {
      const new_models = [{name: 'count_videos', value: val[0] === 0 && val[1] === 20000 ? null : val}]
      this.changeFilter('count_videos', new_models, val[0] === 0 && val[1] === 20000 ? null : this.getLabelRange(val, 0, 20000, separatebycomma, 'search.anyQuantity'))
    },
    range_views(val) {
      const new_models = [{name: 'range_views', value: val[0] === 10000 && val[1] === 10000000 ? null : val}]
      this.changeFilter('range_views', new_models, val[0] === 10000 && val[1] === 10000000 ? null : this.getLabelViews())
    },
    engagement_rate(val) {
      const new_models = [{name: 'engagement_rate', value: val !== 0 ? val : null}]
      this.changeFilter('engagement_rate', new_models, val !== 0 ? val : null)
    },
    mentioned_any(val) {
      const new_models = [{name: 'mentioned_any', value: val}]
      this.changeFilter('mentioned_any', new_models, val === false ? this.$t('lists.none') : this.$t('search.realty.any'))
      if (this.loaded_services_history) this.getCounter()
    }
  }
}
</script>

<style lang="scss" scoped>
.selected-location-item {
  background-color: #F1F5F9;
  border-radius: 8px;
  padding: 12px 16px;
  color: #475569;
  font-size: 0.95rem;
}
.selected-location-or {
  color: #94A3B8;
  margin: 6px 0;
  font-size: 0.9rem;
}
.badge-blue-filter-searcher-new {
  background-color: #0096fe;
  color: white;
  max-height: 20px;
}
.p-custom {
  padding: 0 1.28rem 0.5rem 1.28rem;
}
.p-05 {
  padding: 0.5em;
}
.mr-03 {
  margin-right: 0.3em;
}
.container-more-filters {
  @media(max-width: 991px) {
    width: 100%;
    margin-top: 1em;
  }
  @media(min-width: 992px) {
    margin-left: 1em;
  }
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
.select-network-search {
  width: auto;
  @media(max-width: 991px) {
    width: 100% !important;
  }
}
.value-active {
  cursor: pointer;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: none;

  width: 100%;
  height: 100%;
  background-color: white;
  transition: all .3s;
  border: 2px solid #7367f0;
}
.value-inactive {
  cursor: pointer;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: none;
  width: 100%;
  height: 100%;
  background-color: gray;
  transition: all .3s;
  border: 2px solid white;
}
  .spinner-ubication {
    position: absolute; 
    right: 20px; top: 28px
  }
  </style>
  
<style lang="scss">
#card-youtube-filters > .card-body {
  padding: 8px 20px 8px 8px;
  display: flex;
  align-items: center;
  @media(max-width: 991px) {
    flex-wrap: wrap;
    padding: 8px;
  }
}
.icon-size-14 {
  position: absolute;
  width: 14px;
  height: 14px;
  left: 15px;
}
.categories-youtube-filter {
  width: 750px;
  font-size: 13px;
  max-height: 420px;
  overflow: hidden;
}
</style>
